var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJobDispatching(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 14.5253V1.47465C15.0003 0.660138 14.2166 -0.00028783 13.25 9.41084e-08H2.75C1.7834 -0.00028783 0.999658 0.660138 1 1.47465V14.5253C0.999658 15.3399 1.7834 16.0003 2.75 16H13.25C14.2166 16.0003 15.0003 15.3399 15 14.5253ZM10.1213 10.8787C10.6839 11.4413 11 12.2044 11 13H5C5 12.2044 5.31607 11.4413 5.87868 10.8787C6.44129 10.3161 7.20435 10 8 10C8.79565 10 9.55871 10.3161 10.1213 10.8787ZM7.99522 5.00001C9.10037 4.99738 9.99812 5.89158 10 6.99672C10.0017 8.10187 9.10674 8.99906 8.00159 9C6.89644 9.00075 6 8.10505 6 6.99991C5.99888 5.89682 6.89195 5.0015 7.99522 5.00001ZM6.4 3.3678H9.6C9.82094 3.3678 10 3.14377 10 2.8678C10 2.59163 9.82094 2.3678 9.6 2.3678H6.4C6.17922 2.3678 6 2.59163 6 2.8678C6 3.14377 6.17922 3.3678 6.4 3.3678Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 13.0004C11 12.2047 10.6839 11.4417 10.1213 10.879C9.55871 10.3164 8.79565 10.0004 8 10.0004C7.20435 10.0004 6.44129 10.3164 5.87868 10.879C5.31607 11.4417 5 12.2047 5 13.0004H11Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 6.99709C9.99812 5.89194 9.10037 4.99775 7.99522 5.00037C6.89195 5.00187 5.99888 5.89719 6 7.00028C6 8.10542 6.89644 9.00111 8.00159 9.00037C9.10674 8.99943 10.0017 8.10224 10 6.99709Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6 3.36816H6.4C6.17922 3.36816 6 3.14414 6 2.86816C6 2.59199 6.17922 2.36816 6.4 2.36816H9.6C9.82094 2.36816 10 2.59199 10 2.86816C10 3.14414 9.82094 3.36816 9.6 3.36816Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobDispatching);
export default __webpack_public_path__ + "static/media/job-dispatching.e1558880.svg";
export { ForwardRef as ReactComponent };